import Container from '@/components/Container/Container';
import { SBImage } from '@/components/ImageService/SBImage';
import { Typography } from '@/shared';
import { ProjectsStoryblok } from '@/shared/types/storyblok/storyblok-types';
import clsx from 'clsx';
import Link from 'next/link';
import { useMemo, useState } from 'react';
import { FreeMode, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SwiperVariables } from '../../SwiperVariables';
import styles from '../ProjectListing.module.scss';
import SingleCard from '../ui/SingleCard';

interface MobileProjectListingProps {
    content: ProjectsStoryblok[];
    isDark: boolean;
    xSmall: boolean;
}

const ProjectListingMobile: React.FC<MobileProjectListingProps> = ({ content, isDark, xSmall }) => {
    const [swiper, setSwiper] = useState<any | null>(null);
    const SwiperConfig = useMemo(
        () => ({
            modules: [Scrollbar, FreeMode],
            style: SwiperVariables(isDark) as Object,
            slidesPerView: xSmall ? 1.1 : 1.5,
            spaceBetween: 12,
            scrollbar: { draggable: true, snapOnRelsease: true },
            freemode: { sticky: false },
            onSwiper: (swiper: any) => setSwiper(swiper),
        }),
        [isDark, xSmall],
    );
    return (
        <Container code="fullpage" className={{ wrap: styles.wrapper }}>
            {content && content.length > 1 ? (
                <Swiper {...SwiperConfig} className={styles.swiper}>
                    {content.slice(0, content.length).map((element: ProjectsStoryblok) => {
                        const { _uid, mainImage, clientName, title } = element.content;
                        return (
                            <SwiperSlide className={styles.slide} key={element.uuid}>
                                {({ isNext, isPrev }) => (
                                    <div
                                        key={_uid}
                                        className={styles.card}
                                        onClick={() => {
                                            if (isNext) {
                                                swiper?.slideNext();
                                            } else if (isPrev) {
                                                swiper?.slidePrev();
                                            }
                                        }}
                                    >
                                        <Link
                                            scroll={true}
                                            href={element.full_slug}
                                        >
                                            {mainImage?.filename && (
                                                <SBImage image={mainImage} height={256} fit="cover" />
                                            )}
                                            <div className={styles.infos}>
                                                <div className={clsx({ [styles.space]: !clientName })}>
                                                    <Typography.Small className={styles.preTitle}>
                                                        {clientName}
                                                    </Typography.Small>
                                                </div>
                                                <Typography.H3 className={styles.title}>{title}</Typography.H3>
                                            </div>
                                        </Link>
                                    </div>
                                )}
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            ) : (
                <SingleCard content={content} isMobile />
            )}
        </Container>
    );
};

export default ProjectListingMobile;
